import { HttpMethod } from './http-service-constants.js';
import { createHttpRequestParameters, createRequest, getMappedResponse, httpError, HttpError, isResponseStatusUnauthorized, resolveEndpointURL } from './http-service-utils.js';
function createHttpService() {
    let authentication;
    let base;
    let configured = false;
    function applyAuthHeaders(request) {
        if (!authentication) {
            return;
        }
        for (const [key, value] of authentication.getHeaders()) {
            request.headers.set(key, value);
        }
    }
    function checkUnauthorized(request, response) {
        if (!isResponseStatusUnauthorized(response) || !authentication) {
            return Promise.resolve(response);
        }
        return authentication.requestRefreshToken()
            .then(() => {
            applyAuthHeaders(request);
            return fetch(request);
        });
    }
    function configure(configuration) {
        if (configured) {
            throw httpError('Service already configured.');
        }
        if (configuration.authentication) {
            authentication = configuration.authentication;
        }
        if (configuration.base) {
            base = configuration.base;
        }
        configured = true;
    }
    function hasBeenConfigured() {
        return configured;
    }
    function httpDelete(endpoint, endpointParameters, options) {
        const parameters = createHttpRequestParameters(HttpMethod.DELETE, endpoint, endpointParameters, options);
        return httpFetch(parameters);
    }
    function httpGet(endpoint, endpointParameters, options) {
        const parameters = createHttpRequestParameters(HttpMethod.GET, endpoint, endpointParameters, options);
        return httpFetch(parameters);
    }
    function httpPost(endpoint, endpointParameters, options) {
        const parameters = createHttpRequestParameters(HttpMethod.POST, endpoint, endpointParameters, options);
        return httpFetch(parameters);
    }
    function httpPut(endpoint, endpointParameters, options) {
        const parameters = createHttpRequestParameters(HttpMethod.PUT, endpoint, endpointParameters, options);
        return httpFetch(parameters);
    }
    function httpFetch(parameters) {
        const { abortController, body, endpoint, endpointParameters, headers, method, } = parameters;
        const resolvedURL = resolveEndpointURL(endpoint, endpointParameters, base);
        const request = createRequest(method, resolvedURL, headers, abortController, body);
        applyAuthHeaders(request);
        const clonedRequest = request.clone();
        return fetch(request)
            .then(response => checkUnauthorized(clonedRequest, response))
            .then(response => getMappedResponse(response));
    }
    return {
        configure,
        delete: httpDelete,
        fetch: httpFetch,
        get: httpGet,
        hasBeenConfigured,
        post: httpPost,
        put: httpPut,
    };
}
const HttpService = createHttpService();
export { createHttpRequestParameters, HttpError, HttpService, };
//# sourceMappingURL=http-service.js.map